import { render, staticRenderFns } from "./SignUpFranchiseStepOne.vue?vue&type=template&id=6baefe8a&scoped=true&"
import script from "./SignUpFranchiseStepOne.vue?vue&type=script&lang=js&"
export * from "./SignUpFranchiseStepOne.vue?vue&type=script&lang=js&"
import style0 from "./SignUpFranchiseStepOne.vue?vue&type=style&index=0&id=6baefe8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baefe8a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LogoWithTradeMark: require('/home/circleci/repo/components/LogoWithTradeMark.vue').default,VButton: require('/home/circleci/repo/components/VButton.vue').default})
